
import { Link }from "react-router-dom";
import "../../Styles/Loginpage/Loginpage.css";


export default function LoginPageUsingEmail() {
 

  return (
    <div>
      <div className="login-card">
        <img
          src="/static/media/logo.25ae0241f5bf7d7c5384da9376d392bc.svg"
          alt="YellowCalf Logo"
          className="login-logo"
        />

        <hr className="divider" />
        <h4 className="login-heading">Sign in to your account</h4>

        <div className="input-group">
          <span className="input-icon">
            <i className="bi bi-envelope"></i>
          </span>
          <input
            type="email"
            className="form-control"
            placeholder="Email ID" />
        </div>

        {/* Links and Buttons */}
        <div className="login-actions">
          <Link to="/login" className="link-btn" >
            <i className="bi bi-person-fill"></i> Login using Password
          </Link>

          <Link to="" className="otp-btn custom-btn" >
            Generate OTP <i className="bi bi-arrow-right-circle-fill"></i>
          </Link>
        </div>

    
        <p className="footer-text"> 2025 © YellowCafl</p>
      </div>
    </div>
  );
}
